import {goalsApiClient} from '../GoalsApiClient';
import {GoalModelType} from '../models/GoalModelType';
import {isInvestablySufficient} from '../../Portfolio/portfolioUtils';

/**
 * If the profile is investably sufficient, the Lifestyle goal should not be funded by non-investable assets.
 * This function persists the normalization and returns the updated goal model.
 */
export const normalizeLifestyleGoalForSufficiency = async (goalModel: GoalModelType, enableEnhancedLifestyleFunding: boolean): Promise<GoalModelType> => {
    const {proposal, assets, investorGroup} = goalModel;
    const lsGoal = goalModel.lifestyleSpendingGoal;

    const isSufficient = isInvestablySufficient({
        ...goalModel,
        totalInvestableValue: assets.totalInvestableValue,
        lifestylePresentValue: lsGoal.calculatedFields,
        enableEnhancedLifestyleFunding: enableEnhancedLifestyleFunding,
    });

    // Only normalize when sufficient AND currently funded by non-investable assets.
    if (!isSufficient || !lsGoal.userInputs.isFundedByNonInvestableAssets) return goalModel;

    // Persist normalization.
    const lifestyleSpendingRequest = {
        id: lsGoal.id,
        userInputs: {
            ...lsGoal.userInputs,
            isFundedByNonInvestableAssets: false,
            totalFundedByNonInvestableAssetsAmount: null,
        },
        lengthOfPlanningPeriod: investorGroup.planningPeriod.numberOfYears,
    };
    const saved = enableEnhancedLifestyleFunding
        ? await goalsApiClient.postLifeStyleGoalv3(proposal.id, lifestyleSpendingRequest)
        : await goalsApiClient.postLifeStyleGoal(proposal.id, lifestyleSpendingRequest);

    return {
        ...goalModel,
        lifestyleSpendingGoal: saved,
    };
};
